import React from 'react';
import './CustomSpinner.css';

function CustomSpinner() {
  return (
    <div className="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default CustomSpinner;
